import { useQuery } from "@tanstack/react-query";

const useAllVolunteer = () => {
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;
  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: allVolunteerInfo = [],
  } = useQuery({
    queryKey: ["allVolunteerInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/voluntaryListAll/${user_id}`
      );
      const data = await res.json();
      return data;
    },
  });
  return [allVolunteerInfo, isLoading, isError, error, isSuccess, refetch];
};

export default useAllVolunteer;
